export const labelColSpan = 8
export const layout = {
  labelCol: { span: labelColSpan },
  wrapperCol: { span: 12 },
}

export const tailLayout = {
  wrapperCol: { offset: labelColSpan, span: 12 },
}
